import { Link } from 'react-router-dom';

import { PageContainer } from '@/components/common/PageContainer';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <PageContainer className="flex flex-col items-center justify-center py-20 text-center">
      <h1 className="text-6xl font-bold text-neutral-900">404</h1>
      <p className="mt-4 text-lg text-neutral-600">
        The page you are looking for does not exist.
      </p>
      <Link to="/" className="mt-8">
        <Button variant="outline">Back to Home</Button>
      </Link>
    </PageContainer>
  );
}
